import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import { MenuGroup } from '../types/sidebar';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements AfterViewInit {
  public parentId = "";

  menuGroups: MenuGroup[] = [
    {
      categoryTitle: 'SIDEBAR.VIEWS.TITLE',
      items: [
        { title: 'SIDEBAR.VIEWS.DASHBOARD', icon: 'mdi mdi-view-dashboard', route: '/dashboard' },
        /*{
          title: 'SIDEBAR.VIEWS.MAP',
          icon: 'mdi mdi-layers',
          id: 'nav-link-map',
          children: [
            { title: 'Map1', route: '/map/map1' },
            { title: 'Map2', route: '/map/map2' }
          ]
        },*/
        /*{ title: 'SIDEBAR.VIEWS.REAL_TIME_VISITORS', icon: 'mdi mdi-account-multiple', route: '/real-time-visitors' },*/
        { title: 'SIDEBAR.VIEWS.LIVE_VIEW', icon: 'mdi mdi-pulse', route: '/live-view' },
        { title: 'SIDEBAR.VIEWS.STATISTICS', icon: 'mdi mdi-chart-bar', route: '/statistics' }
      ]
    },
    {
      categoryTitle: 'SIDEBAR.SYSTEM_SETTINGS.TITLE',
      items: [
        { title: 'SIDEBAR.SYSTEM_SETTINGS.SETTINGS', icon: 'fa fa-gear', route: '/settings' },
        /*{ title: 'SIDEBAR.SYSTEM_SETTINGS.ORGANISATIONS', icon: 'mdi mdi-map-marker-radius', route: '/organisations' },
        { title: 'SIDEBAR.SYSTEM_SETTINGS.UPLOAD_DATA', icon: 'fa fa-upload', route: '/upload-data' }*/
      ]
    },
    {
      categoryTitle: 'SIDEBAR.ADMIN_PANEL.TITLE',
      items: [
        { title: 'SIDEBAR.ADMIN_PANEL.ADMIN', icon: 'mdi mdi-wrench', route: '/admin' }
      ]
    }
  ];

  constructor() {
  }

  ngAfterViewInit() {
    const body = document.querySelector('body');
    if (!body) return;

    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll('.sidebar .nav-item').forEach(function(el) {
      el.addEventListener('mouseover', function() {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

  clickedMenu(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const parentId = target.id;
    if (parentId == this.parentId) {
      this.parentId = "";
    } else {
      this.parentId = target.id;
    }
  }
}
